import get from 'lodash/get';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';

import injectSaga from '../../../redux/injectSaga';
import { RESTART_ON_REMOUNT } from '../../../redux/sagaInjectors';
import consentSaga from '../../../redux/surveys/sagas/consent-saga';
import { actions as exportToPDFActions } from '../../../redux/surveys/exportToPDF';
import {
  targetUserSelector,
  targetUserIdSelector,
} from '../../../redux/context/selectors';

import styles from '../index.styl';

const mapStateToProps = state => ({
  targetUser: targetUserSelector(state),
  targetUserId: targetUserIdSelector(state),
  exportPDFState: get(state, 'surveys.pdfExport'),
  surveysLoading: get(state, 'surveys.answered.sending'),
});

const mapDispatchToProps = {
  exportToPDF: exportToPDFActions.send,
  clearExportToPDF: exportToPDFActions.clear,
};

export const enhance = compose(
  injectSaga({
    key: 'consentSaga',
    saga: consentSaga,
    mode: RESTART_ON_REMOUNT,
  }),
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Surveys/SurveysResults/enhance.js